module.exports = __webpack_public_path__ + "img/detallecurso5.372fe1c6.png";